import { render, staticRenderFns } from "./EvidenceDetails.vue?vue&type=template&id=6a70ccce"
import script from "./EvidenceDetails.vue?vue&type=script&lang=ts"
export * from "./EvidenceDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports